exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Loader--medium {\n  width: 70px;\n  height: 70px; }\n\n.Loader--small {\n  width: 30px;\n  height: 30px; }\n\n.Loader--x-small {\n  width: 25px;\n  height: 25px; }\n\n.Loader--large {\n  width: 100px;\n  height: 100px; }\n", ""]);

